var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg13Time(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4999 0C21.3576 0 16.3308 1.52487 12.0551 4.38179C7.77948 7.2387 4.44701 11.2993 2.47914 16.0502C0.511265 20.8011 -0.00361959 26.0288 0.999593 31.0723C2.00281 36.1158 4.47906 40.7486 8.11521 44.3848C11.7514 48.0209 16.3841 50.4972 21.4276 51.5004C26.4711 52.5036 31.6988 51.9887 36.4497 50.0209C41.2005 48.053 45.2611 44.7205 48.1181 40.4448C50.975 36.1691 52.4998 31.1423 52.4998 26C52.4589 19.117 49.7065 12.5275 44.8394 7.66045C39.9723 2.79335 33.3829 0.0409307 26.4999 0Z",
    fill: "#26B89A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5005 0C26.5008 9.1 26.5006 14.3 26.5 26C38.2003 26 43.3999 26 52.5004 26C52.4595 19.117 49.7071 12.5275 44.84 7.66045C39.9729 2.79335 33.3835 0.0409307 26.5005 0Z",
    fill: "#20493C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8494 28.6001H26.4994C25.8098 28.6001 25.1485 28.3262 24.6609 27.8386C24.1733 27.351 23.8994 26.6897 23.8994 26.0001V13.1562C23.8994 12.4666 24.1733 11.8053 24.6609 11.3177C25.1485 10.8301 25.8098 10.5562 26.4994 10.5562C27.189 10.5562 27.8503 10.8301 28.3379 11.3177C28.8255 11.8053 29.0994 12.4666 29.0994 13.1562V23.4001H38.8494C39.5389 23.4001 40.2002 23.6741 40.6878 24.1617C41.1754 24.6493 41.4493 25.3106 41.4493 26.0001C41.4493 26.6897 41.1754 27.351 40.6878 27.8386C40.2002 28.3262 39.5389 28.6001 38.8494 28.6001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13Time);
export default __webpack_public_path__ + "static/media/13_time.867346a3a26ba617144da3a410160780.svg";
export { ForwardRef as ReactComponent };